import React from 'react';

import {ChainDomainSizing, SharedDomainParams} from 'antibodies/AntibodyTypedefs';

import AntibodyComponentPopover from './AntibodyComponentPopover';

export type AntibodyFusionDomainProps = SharedDomainParams & {
  /* What color the fill (i.e. background) of the domain should be */
  fillColor: string;
  /* What color the stroke (i.e. border) of the domain should be */
  strokeColor: string;
  chainDomainSizing: ChainDomainSizing;
};

/**
 * A colored oval representing a fusion domain.
 * This is an SVG component, so all units are 'abstract user units', relative to the SVG viewbox.
 * @param fillColor The fill color of the oval
 * @param strokeColor The stroke color of the oval
 * @param chainDomainSizing The sizing params for this format's chain domains
 */
export default function AntibodyFusionDomain({
  antibodyId,
  fillColor,
  strokeColor,
  chainDomainSizing,
  proteinId,
  inaccessible,
  label,
  showPopovers,
}: AntibodyFusionDomainProps): JSX.Element {
  const {height, width} = chainDomainSizing;
  return (
    <AntibodyComponentPopover
      antibodyId={antibodyId}
      proteinId={proteinId}
      inaccessible={inaccessible}
      componentLabel={label}
      showPopovers={showPopovers}
    >
      <ellipse
        rx={width / 2}
        ry={height / 2}
        cx={width / 2}
        cy={height / 2}
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={strokeColor === 'transparent' ? 0 : width / 16}
        shapeRendering="geometricPrecision"
      />
    </AntibodyComponentPopover>
  );
}
